import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import posthog from "../../posthog";

/**
 * /invite/:name route handler.
 *
 * 1. Captures the :name param
 * 2. Stores it in localStorage so the rest of the app knows this
 *    user came from a personalized link
 * 3. Identifies the user in PostHog
 * 4. Redirects to /2026
 *
 * Usage:
 *   yourdomain.com/invite/ali      → identified as "ali", redirected to /2026
 *   yourdomain.com/invite/sarah    → identified as "sarah", redirected to /2026
 *   yourdomain.com/invite/test123  → identified as "test123", redirected to /2026
 */
export default function InviteRedirect() {
  const { name } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!name) {
      navigate("/2026", { replace: true });
      return;
    }

    const arrivedAt = new Date().toISOString();

    // Flag localStorage
    localStorage.setItem("invite_ref", name);
    localStorage.setItem("invite_arrived_at", arrivedAt);

    // Identify in PostHog (if loaded)
    if (posthog.__loaded) {
      posthog.identify(name, {
        source: name,
        arrived_at: arrivedAt,
      });
      posthog.register({ invite_ref: name });
      posthog.capture("invite_link_opened", {
        invite_name: name,
        arrived_at: arrivedAt,
      });
    }

    // Redirect to the 2026 valentine page
    navigate("/2026", { replace: true });
  }, [name, navigate]);

  // Render nothing — this is a redirect-only route
  return null;
}
